module.exports = __webpack_public_path__ + "img/pro.f1c84d2f.png";